import { WAMeterCase } from '@/types';

export const getReason = (mc: WAMeterCase) => {
	if (!mc.meterManagementProjectType) return '';
	if (mc.meterManagementProjectType == 'Ad-hoc') {
		return mc.caseType;
	} else {
		return mc.meterManagementProjectType;
	}
};

export const getMeterCaseReferenceInfo = (mc: WAMeterCase): DeviceReferenceInfo => {
	const defaultInfo = {
		label: 'Device reference',
		value: '',
	};
	const deviceReferenceInfo = {
		label: 'Device reference',
		value: mc.deviceReference || '',
	};
	const waterAccountReferenceInfo = {
		label: 'Water account reference',
		value: mc.waterAccountReference || '',
	};

	switch (mc.meterManagementProjectType) {
		case 'Revalidation':
			return deviceReferenceInfo;
		case 'New metered area':
			return waterAccountReferenceInfo;
		case 'Ad-hoc':
			switch (mc.caseType) {
				case 'Meter Validation':
				case 'Replacement':
					return deviceReferenceInfo;
				case 'New Meter':
					return waterAccountReferenceInfo;
				default:
					return defaultInfo;
			}
		case 'Faulty':
			return deviceReferenceInfo;
		default:
			return defaultInfo;
	}
};

interface DeviceReferenceInfo {
	label: string;
	value: string;
}
